class OTFControlSearch {
    container = '#otf-customize-quick-search';

    constructor() {
        if ($('#customize-header-actions').length > 0) {
            this.init();
        }
    }

    init() {
        //$('#customize-header-actions').prepend(this.renderHtml())
    }


    /**
     * @return {string}
     */
    renderHtml() {
        let _html = `<div id="${this.container.replace('#', '')}">
    <input class="search-for" type="text" value="" placeholder="Search...">
    <div class="search-results hidden"></div>
</div>`;
        return _html;
    }
}